import { render, staticRenderFns } from "./AdminServiceAreaList.vue?vue&type=template&id=7139fc8c"
import script from "./AdminServiceAreaList.vue?vue&type=script&lang=js"
export * from "./AdminServiceAreaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports